// Imágenes en formatos livianos (AVIF / WebP) para que la página cargue rápido.
export const bookPreviewPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/x62uMozVouvkgTUdPdBiWT/o_1iu7s8ffe170u1s6a17sr1g4k1foc1p.avif',
    title: 'Aceite crismal',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kicJcg447vfvEjaRP47bXU/C.webp',
    title: 'La glándula pineal',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9uV4ZPPhgEsyjMyDvunSCo/a0ca159027a828fb8338b2722df7c530.webp',
    title: 'Conciencia',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vqxvctnJb6ZHciyWroSoMb/163bee26c7b647d3a973b65b86953b2c.webp',
    title: 'Chakras',
  },
]
